import axios from "axios";
import {selectUrl} from './baseUrl';

export const GOOGLE_ANALYTICS_TRACKING_ID = "UA-250219646-1";

const api = axios.create({
  baseURL: selectUrl(),
});

api.interceptors.request.use(config => {

  const token = localStorage.getItem('token');
  const selectedTenant = localStorage.getItem('selectedTenant');
  try {
    if (token)
      config.headers.Authorization = "bearer " + token;
    if (selectedTenant)
      config.headers.Tenant = selectedTenant;

    return config;
  } catch (err) {
    console.log('err', err)
  }
})


export default api;



